// src/components/MasonryImageGrid.js
import React from "react";
import styled from "styled-components";
import tw from "twin.macro";

const GridWrapper = tw.div`
  max-w-screen-xl 
  mx-auto 
  px-4 
  py-4
`;

const MasonryGridContainer = styled.div`
  column-count: 1;
  column-gap: 1rem;
  @media (min-width: 640px) {
    column-count: 2;
  }
  @media (min-width: 768px) {
    column-count: 3;
  }
`;

const MasonryItem = styled.div`
  display: inline-block;
  width: 100%;
  margin-bottom: 1rem;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 1.5rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.6);
  }
  &:hover img {
    transform: scale(1.2);
  }
  &:hover .overlay {
    opacity: 1;
  }
`;

const StyledImage = styled.img`
  ${tw`w-full h-auto object-cover transition-transform duration-300`}
  display: block;
`;

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: 1rem;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.7) 30%,
    rgba(0, 0, 0, 0)    70%
  );
  opacity: 0;
  transition: opacity 0.3s ease;
`;

const HeaderText = tw.h3`
  text-white text-lg font-bold text-center px-2 pt-5
`;

const MasonryImageGrid = ({ items = [], onItemClick }) => (
  <GridWrapper>
    <MasonryGridContainer>
      {items.map((item) => (
        <MasonryItem key={item.id} onClick={() => onItemClick?.(item)}>
          <StyledImage src={item.imageUrl} alt={item.header} />
          <Overlay className="overlay">
            <HeaderText>{item.header}</HeaderText>
          </Overlay>
        </MasonryItem>
      ))}
    </MasonryGridContainer>
  </GridWrapper>
);

export default MasonryImageGrid;
